module.exports = __webpack_public_path__ + "img/Cymbal_Average.2c47656a.png";